import { zipSync, unzipSync, type Zippable } from 'fflate';

export interface ZipEntry {
  path: string;
  data: Uint8Array;
  /** true → store (no compression), default: deflate */
  store?: boolean;
}

/** 엔트리 배열로부터 ZIP 바이너리를 생성 */
export function createZip(entries: ZipEntry[]): Uint8Array {
  const data: Zippable = {};

  for (const entry of entries) {
    data[entry.path] = entry.store
      ? [entry.data, { level: 0 }]
      : entry.data;
  }

  return zipSync(data);
}

/** ZIP 바이너리를 엔트리 맵으로 추출 */
export function extractZip(data: Uint8Array): Record<string, Uint8Array> {
  return unzipSync(data);
}

/** 문자열을 UTF-8 Uint8Array로 인코딩 */
export function encodeUtf8(str: string): Uint8Array {
  return new TextEncoder().encode(str);
}

/** Uint8Array를 UTF-8 문자열로 디코딩 */
export function decodeUtf8(data: Uint8Array): string {
  return new TextDecoder().decode(data);
}
